var lib_core  = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var SelectionGridModel          = require("./selectionGridModel.js");
var Editor2DController          = require("./../editor2D/editor2DController.js");

var SelectionGridController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SelectionGridController, lib_core.Controller);
SelectionGridController.inject = {
    editor2DController : Editor2DController
};

module.exports = SelectionGridController;

SelectionGridController.prototype.createModel = function () {
    var editorModel = this.editor2DController.getModel();
    var editorView = this.editor2DController.getView();
    return new SelectionGridModel(editorModel, this.configuration, editorView);
};
